import { Controller } from '@hotwired/stimulus'

const borderClass = 'border-0.25'
const borderPrimary = 'border-primary'
const borderDark = 'border-neutral-300'

const selectedPictoClass = 'img.selector-picto.select'
const notSelectedPictoClass = 'img.selector-picto.unselect'

const hiddenVisibilityClass = 'hidden'

export default class extends Controller {
  static targets = ['card']

  select() {
    let selectedActionSuggestionCard = event.currentTarget
    if (this.isCardAlreadySelected(selectedActionSuggestionCard)) {
      this.unselectCard(selectedActionSuggestionCard)
    } else {
      this.unselectAllCards()
      this.selectCard(selectedActionSuggestionCard)
    }
  }

  isCardAlreadySelected(card) {
    return card.classList.contains(borderPrimary)
  }

  unselectAllCards() {
    this.cardTargets.forEach(card => this.unselectCard(card))
  }

  selectCard(card) {
    this.drawColorBorder(card)
    this.tickSelector(card)
  }

  unselectCard(card) {
    this.removeColorBorder(card)
    this.untickSelector(card)
  }

  drawColorBorder(card) {
    card.classList.remove(borderClass, borderDark)
    card.classList.add(borderClass, borderPrimary)
  }

  removeColorBorder(card) {
    card.classList.remove(borderClass, borderPrimary)
    card.classList.add(borderClass, borderDark)
  }

  tickSelector(card) {
    card.querySelector(selectedPictoClass).classList.remove(hiddenVisibilityClass)
    card.querySelector(notSelectedPictoClass).classList.add(hiddenVisibilityClass)
  }

  untickSelector(card) {
    card.querySelector(selectedPictoClass).classList.add(hiddenVisibilityClass)
    card.querySelector(notSelectedPictoClass).classList.remove(hiddenVisibilityClass)
  }
}
